import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

type ProtectedRouteProps = {
  children: React.ReactElement;
  redirectTo?: string;
};

function FullScreenLoader() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#f7f8fa",
        color: "#374151",
        fontSize: "0.95rem",
      }}
    >
      Loading...
    </div>
  );
}

export default function ProtectedRoute({
  children,
  redirectTo = "/login",
}: ProtectedRouteProps) {
  const { user, sessionLoading } = useAuth();
  const location = useLocation();

  if (sessionLoading) {
    return <FullScreenLoader />;
  }

  if (!user) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  return children;
}